import { render, staticRenderFns } from "./Dpointro.vue?vue&type=template&id=0536dd7e&"
import script from "./Dpointro.vue?vue&type=script&lang=js&"
export * from "./Dpointro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports